import { useQuery } from "@tanstack/react-query";
import { fetcher } from "../../../utils/Axios";

const GET_DELAYED_END_SEVERITY_FREQUENCY_QUERY_KEY = "delayedEndSeverityFrequency";

async function getDelayedEndSeverityFrequency(
  tenantId: string,
  hospitalId: string,
  queryString: string = ""
) {
  const { data } = await fetcher({
    url: `analytics/delayed-end-severity-frequency?${queryString}`,
    method: "GET",
    headers: {
      "x-tenant-id": tenantId,
      "x-hospital-id": hospitalId,
    },
  });
  return data;
}

export default function useGetDelayedEndSeverityFrequencyQuery(
  tenantId: string,
  hospitalId: string,
  queryString: string = ""
) {
  return useQuery({
    queryKey: [GET_DELAYED_END_SEVERITY_FREQUENCY_QUERY_KEY, queryString, hospitalId],
    queryFn: () => getDelayedEndSeverityFrequency(tenantId, hospitalId, queryString),
    refetchInterval: 60000,
  });
} 